module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/bracelets/silver-boutique-dbe5d1c5a61af88b65a5acac8818a123.webp";